import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { cloneDeep, set, isEmpty } from 'lodash';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Loader from '../../../Components/Utility/Loader/Loader';
import { customStylesForOCP, careManualTypeList, manualStatusColours } from '../../../Components/helper';
import { CareUserContext } from './provider/careUserContext';
import { commonPath } from './fieldPath';
import ManualColumnSection from './ManualColumnSection';
import * as action from './store/UserInstruction.action';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import ColourComponent from './ColourComponent';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

export default function AddEditCareColumn() {
  const { t } = useTranslation('common');
  const { _id } = useParams();
  const { state, setState, validateColumns } = useContext(CareUserContext);
  const dispatch = useDispatch();

  const {
    UserDetails: { userInfo },
  } = useSelector((reducer) => reducer);

  const addCard = () => {
    setState((prevState) => ({
      ...prevState,
      addColumns: [
        ...prevState.addColumns,
        {
          name: '',
          columnType: null,
          isRequired: false,
          options: [{ name: '' }],
          status: null,
          statusColoursOptions: manualStatusColours,
          isStatusEditTrue: false,
          characterLimit: '',
          colorSwitch: false,
          colourArray: [
            {
              colourValue: '',
              colourType: 'green',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'amber',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'red',
              startPercentage: '',
              endPercentage: '',
            },
          ],
        },
      ],
    }));
  };
  function deleteCard(index) {
    const updatedCards = cloneDeep(state?.addColumns);
    updatedCards.splice(index, 1);
    setState((oldState) => ({ ...oldState, addColumns: updatedCards }));
  }
  function handleClose() {
    setState((prevState) => ({
      ...prevState,
      showAddEditColumn: false,
      editMode: false,
      addColumns: [],
    }));
  }
  const handleSubmit = async () => {
    if (validateColumns()) {
      toasterMsg(t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.PLEASE_FILL_ALL_MEDATORY_FIELDS'), 'danger');
      return;
    }
    const transformedColumns = state?.addColumns?.map((column) => {
      const columnDetails = { columnType: column?.columnType, isRequired: column?.isRequired };
      if (column?.columnType?.key === 'Textbox') {
        columnDetails.characterLimit = column?.characterLimit;
      } else if (['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button']?.includes(column?.columnType?.key)) {
        columnDetails.options = column?.options;
      } else if (column?.columnType?.key === 'Status') {
        columnDetails.status = column?.status;
        columnDetails.statusColoursOptions = column?.statusColoursOptions;
        columnDetails.isStatusEditTrue = column?.isStatusEditTrue;
      } else if (['Number_Decimal', 'Number_percentage'].includes(column?.columnType?.key)) {
        columnDetails.colourArray = column?.colourArray;
      }
      return {
        name: column?.name || '',
        columnDetails,
        isDefault: false,
        tabId: _id,
        createdBy: userInfo?.userId,
      };
    });
    const params = {
      columns: transformedColumns,
    };
    if (state?.editMode) {
      params.columnId = state?.addColumns?.[0]?._id;
    } else {
      params.columns = params?.columns?.map((column, columnIndex) => ({ ...column, sequence: state.columns.length + columnIndex + 1 }));
    }
    setState((prevState) => ({
      ...prevState,
      columnModalLoading: true,
    }));
    await dispatch(action.addUpdateColumnDetailList(_id, params, t));
    await dispatch(action.fetchColumnDetailList(_id));
    handleClose();

    setState((prevState) => ({
      ...prevState,
      columnModalLoading: false,
    }));
  };
  const emptyValues = (nullArray, copyState, pIndex) => {
    if (nullArray && !isEmpty(nullArray)) {
      nullArray.forEach((setNull) => {
        if (setNull === 'colourCoding') {
          set(copyState, commonPath(pIndex, 'colorSwitch')?.COMMON, false);
          set(copyState, commonPath(pIndex, 'colourArray')?.COMMON, [
            {
              colourValue: '',
              colourType: 'green',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'amber',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'red',
              startPercentage: '',
              endPercentage: '',
            },
          ]);
        } else if (setNull === 'options') {
          set(copyState, commonPath(pIndex, 'options')?.COMMON, [{ name: '' }]);
        } else if (setNull === 'statusColoursOptions') {
          set(copyState, commonPath(pIndex, 'statusColoursOptions').COMMON, manualStatusColours);
          set(copyState, commonPath(pIndex, 'status')?.COMMON, null);
          set(copyState, commonPath(pIndex, 'status')?.COMMON, null);
        }
      });
    }
  };
  const handleChange = async (value, path, pIndex, nullArray) => {
    const copyState = state?.addColumns;
    if (nullArray?.length > 0) {
      emptyValues(nullArray, copyState, pIndex);
    }
    set(copyState, path, value);
    copyState[pIndex].hasError = false; // very important
    setState((prevState) => ({ ...prevState, addColumns: copyState }));
  };
  return (
    <Modal className="common-custom-modal modal-medium ocp-modal" show>
      <Modal.Header>
        <Modal.Title>{`${
          state?.editMode ? t('USER_INSTRUCTION_LIBRARY.COLUMN_MODAL.EDIT_COLUMN') : t('USER_INSTRUCTION_LIBRARY.COLUMN_MODAL.ADD_COLUMN')
        }`}</Modal.Title>
        <CustomTooltip tooltipText={t('COMMON_LABEL.CLOSE')}>
          <span onClick={handleClose} aria-label="close" className="icon-close cursor-pointer" />
        </CustomTooltip>
      </Modal.Header>

      <Modal.Body>
        {state.columnLoading ? (
          <Loader />
        ) : (
          <>
            {state?.addColumns?.map((columnEle, columnIndex) => {
              return (
                <div className="d-flex mb-16 add-box-model align-items-start " key={`${state?.selectedTabId}_${columnIndex}`}>
                  <div className="flex-fill ">
                    <div className="flex-fill mb-16  common-input-control fixed-label">
                      <input
                        type="text"
                        name="ColumnName"
                        placeholder={t('PIM_MODULE.COLUMN_MODAL.ADD_EDIT_COLUMN.ENTER_COLUMN_NAME')}
                        className="form-control p-0 col-input"
                        autoComplete="off"
                        value={columnEle?.name}
                        onChange={(e) => handleChange(e?.target?.value, commonPath(columnIndex, 'name')?.COMMON, columnIndex)}
                      />
                      {columnEle.hasError && !columnEle?.name?.trim()?.length && (
                        <span className="error-message">{t('PIM_MODULE.COLUMN_MODAL.ADD_EDIT_COLUMN.NAME_IS_REQUIRED')}</span>
                      )}
                    </div>

                    <div className="flex-fill mb-16 common-react-select option-four">
                      <Select
                        name="columnType"
                        options={careManualTypeList}
                        getOptionLabel={(option) => `${option?.type}`}
                        getOptionValue={(option) => `${option?.key}`}
                        value={columnEle?.columnType}
                        menuPosition="fixed"
                        menuShouldBlockScroll
                        menuShouldScrollIntoView
                        styles={customStylesForOCP}
                        maxMenuHeight={140}
                        onChange={(e) =>
                          handleChange(e, commonPath(columnIndex, 'columnType')?.COMMON, columnIndex, [
                            'colourCoading',
                            'options',
                            'statusColoursOptions',
                            'status',
                            'characterLimit',
                            'colourCoding',
                          ])
                        }
                        className="common-select"
                        classNamePrefix="common-select"
                        isClearable
                        placeholder={t('PIM_MODULE.COLUMN_MODAL.ADD_EDIT_COLUMN.SELECT_COLUMN_TYPE')}
                      />
                      {columnEle?.hasError && !columnEle?.columnType && (
                        <span className="error-message">{t('PIM_MODULE.COLUMN_MODAL.ADD_EDIT_COLUMN.COLUMN_TYPE_REQUIRED')}</span>
                      )}
                    </div>
                    <ManualColumnSection columnEle={columnEle} columnIndex={columnIndex} handleChange={handleChange} />
                    <div className="collapse-card flex-fill mt-2 mb-3">
                      {['Number_Decimal', 'Number_percentage'].includes(columnEle?.columnType?.key) && (
                        <ColourComponent columnEle={columnEle} columnIndex={columnIndex} handleChange={handleChange} />
                      )}
                    </div>
                    <div className="d-flex align-items-center">
                      <p className="custom-radio">
                        <input
                          type="radio"
                          id={`optionalField_${columnIndex}`}
                          name={`optionalField_${columnIndex}`}
                          checked={!columnEle?.isRequired}
                          onChange={(e) => handleChange(!e?.target?.checked, commonPath(columnIndex, 'isRequired')?.COMMON, columnIndex)}
                        />
                        <label className="f-16 text-black font-heavy " htmlFor={`optionalField_${columnIndex}`}>
                          {t('PIM_MODULE.COLUMN_MODAL.ADD_EDIT_COLUMN.OPTIONAL_FIELD')}
                        </label>
                      </p>
                      <p className="custom-radio ml-8">
                        <input
                          type="radio"
                          id={`requiredField_${columnIndex}`}
                          name={`requiredField_${columnIndex}`}
                          checked={columnEle?.isRequired}
                          onChange={(e) => handleChange(e?.target?.checked, commonPath(columnIndex, 'isRequired')?.COMMON, columnIndex)}
                        />
                        <label className="f-16 text-black font-heavy " htmlFor={`requiredField_${columnIndex}`}>
                          {t('PIM_MODULE.COLUMN_MODAL.ADD_EDIT_COLUMN.REQUIRED_FIELD')}
                        </label>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex ml-16 add-btn-container">
                    {(state?.addColumns?.length || 0) - 1 === columnIndex &&
                      !state?.editMode &&
                      (state?.columns?.length || 0) + (state?.addColumns?.length || 0) < 10 && (
                        <button aria-label="add" type="button" onClick={addCard} className="btn mb-16 btn-outline sm" title={t('COMMON_LABEL.ADD')}>
                          <i className="icon-Add f-20" />
                        </button>
                      )}
                    {state?.addColumns?.length > 1 && !state?.editMode && (
                      <button
                        aria-label="delete"
                        type="button"
                        onClick={() => deleteCard(columnIndex)}
                        className="btn  btn-outline sm"
                        title={t('COMMON_LABEL.DELETE')}
                      >
                        <i className="icon-Delete  f-20" />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
            <div className="common-model-footer">
              <CustomTooltip tooltipText={t('COMMON_LABEL.SAVE')}>
                <button onClick={handleSubmit} className="btn p-0" disabled={state?.columnModalLoading} type="button">
                  <i className="icon-Tick-1 f-24" />{' '}
                </button>
              </CustomTooltip>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
